import { jsx } from "react/jsx-runtime";
import MuiRadioGroup from "@mui/material/RadioGroup";
function fieldToRadioGroup({
  field: { onBlur: fieldOnBlur, ...field },
  form,
  onBlur,
  ...props
}) {
  return {
    onBlur: onBlur ?? function(e) {
      fieldOnBlur(e ?? field.name);
    },
    ...field,
    ...props
  };
}
function RadioGroup(props) {
  return /* @__PURE__ */ jsx(MuiRadioGroup, { ...fieldToRadioGroup(props) });
}
RadioGroup.displayName = "FormikMaterialUIRadioGroup";
export {
  RadioGroup,
  fieldToRadioGroup
};
//# sourceMappingURL=RadioGroup.js.map
